module.exports = __webpack_public_path__ + "assets/img/bannerBg.5b464cff.png";